/**
 * Central auth storage using secureStorage.
 * Never store raw passwords; strip sensitive fields from login response.
 */

import { secureStorage } from './security';

const LOGIN_DATA_KEY = 'login_data';
const DIRECT_LINK_KEY = 'directLink';

/** Fields to strip from user object before storing (e.g. backend may return password hash) */
const SENSITIVE_KEYS = ['password', 'password_hash', 'passwordHash', 'token_raw'];

function sanitizeUser(user) {
  if (!user || typeof user !== 'object') return user;
  const out = { ...user };
  SENSITIVE_KEYS.forEach((key) => {
    if (out[key] !== undefined) delete out[key];
  });
  return out;
}

export const authStorage = {
  getLoginData() {
    try {
      const raw = secureStorage.getItem(LOGIN_DATA_KEY);
      if (!raw) return null;
      const data = raw.data ?? raw;
      return sanitizeUser(data);
    } catch {
      return null;
    }
  },

  setLoginData(response) {
    try {
      const toStore = response && typeof response === 'object' ? sanitizeUser(response) : response;
      secureStorage.setItem(LOGIN_DATA_KEY, { data: toStore });
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('authStorage.setLoginData error', e);
      }
    }
  },

  clearLoginData() {
    try {
      secureStorage.removeItem(LOGIN_DATA_KEY);
      try {
        localStorage.removeItem(LOGIN_DATA_KEY);
        localStorage.removeItem(DIRECT_LINK_KEY);
      } catch (_) {}
    } catch (_) {}
  },

  getDirectLink() {
    try {
      return localStorage.getItem(DIRECT_LINK_KEY);
    } catch {
      return null;
    }
  },

  setDirectLink(value) {
    try {
      if (value != null) localStorage.setItem(DIRECT_LINK_KEY, String(value));
      else localStorage.removeItem(DIRECT_LINK_KEY);
    } catch (_) {}
  },
};

export default authStorage;
